import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

export const UNSORTED = "Unsorted";
const PALETTE = ["#0284c7", "#b45309", "#334155", "#7c3aed", "#57534e", "#0d9488", "#ea580c", "#dc2626", "#2563eb", "#65a30d", "#db2777", "#0891b2"];

export function catOf(photo, categories) {
  return categories.includes(photo.category) ? photo.category : UNSORTED;
}

export function catColor(name, categories) {
  const i = categories.indexOf(name);
  return i < 0 ? "#71717a" : PALETTE[i % PALETTE.length];
}

export function usePhotoCategories() {
  const [categories, setCategories] = useState([]);
  const load = useCallback(() => api.get("/photo-categories").then((r) => setCategories(r.data.categories || [])).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  return { categories, setCategories, reload: load };
}
